import React from 'react';
import styled from 'styled-components';

const ScrollWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  touch-action: pan-x;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
`;

interface HorizontalScrollWrapperProps {
  children: React.ReactNode;
}

const HorizontalScrollWrapper: React.FC<HorizontalScrollWrapperProps> = ({
  children,
}) => {
  return (
    <ScrollWrapper id="scroll-wrapper">
      {React.Children.map(children, (child, index) => (
        <div key={index}>{child}</div>
      ))}
    </ScrollWrapper>
  );
};

export default HorizontalScrollWrapper;
